let loadPlyrStyles = null;

export default class Html5Video {
  constructor(el) {
    this.el = el;

    if (!(loadPlyrStyles instanceof Promise)) {
      loadPlyrStyles = new Promise(resolve => {
        const stylesheet = document.createElement('link');
        stylesheet.setAttribute('rel', 'stylesheet');
        stylesheet.href = 'https://cdn.shopify.com/shopifycloud/shopify-plyr/v1.0/shopify-plyr.css';
        stylesheet.onload = resolve;
        document.body.appendChild(stylesheet);
      });
    }

    window.Shopify.loadFeatures([
      {
        name: 'video-ui',
        version: '1.0',
        onLoad: () => loadPlyrStyles.then(() => this._setupVideo()),
      },
    ]);
  }

  /**
   * Setup the video player with Shopify's Plyr library
   *
   * @returns {undefined} - Used as an early return mechanism. Should otherwise be treated
   * as a method that does not return anything.
   * @private
   */
  _setupVideo() {
    if (!Shopify.Plyr) { return; }

    this.player = new Shopify.Plyr(this.el);
    this.player.on('play', () => Core.Media.pauseAll(this.el));
  }

  /**
   * Play the video
   *
   * @returns {Promise} - Whether the video has started to play or not
   * @public
   */
  play() {
    return new Promise((resolve, reject) => {
      if (this.player) {
        this.player.play();
        resolve();
      } else {
        reject();
      }
    });
  }

  /**
   * Pause the video
   * @public
   */
  pause() {
    if (this.player) {
      this.player.pause();
    }
  }

  /**
   * Unload the video player
   * @public
   */
  unload() {
    if (this.player) {
      this.player.destroy();
    }
  }
}
